module.exports = __webpack_public_path__ + "d882638f2b2f00590e30e927c2d705c2.pdf";